import { useQueryClient } from '@tanstack/react-query';
import { getQueryBaseKey } from './getQueryKey';
export const getUseResetQuery = (wrapperOptions) => {
    const useResetQuery = () => {
        const client = useQueryClient();
        return () => {
            const queryKey = getQueryBaseKey(wrapperOptions, 'query');
            return client.resetQueries({ queryKey });
        };
    };
    return useResetQuery;
};
